import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link, useNavigate } from 'react-router-dom';
export function WorkMirrorOnboarding() {
  const navigate = useNavigate();
  const handleBegin = () => {
    navigate('/work-mirror/diagnostic');
  };
  const handleBack = () => {
    navigate('/work-mirror');
  };
  return <>
      <Helmet data-id="element-4104">
        <title data-id="element-4105">Before You Begin — Work Mirror | Lazy Monk Labs</title>
        <meta name="robots" content="noindex, nofollow" data-id="element-4106" />
      </Helmet>

      {/* Dimmed Background Overlay */}
      <div className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-6" data-id="element-4107">
        {/* Modal Card */}
        <div className="relative bg-[#0A0A0A] border-2 border-[#2B2B2B] max-w-lg w-full p-12 space-y-8" data-id="element-4108">
          {/* Title */}
          <h1 className="text-2xl font-medium text-[#F5F5F5]" data-id="element-4109">
            Before you begin
          </h1>

          {/* Body Copy - Very Short */}
          <div className="space-y-4 text-base text-gray-400 leading-relaxed" data-id="element-4110">
            <p data-id="element-4111">This is not a test or an evaluation.</p>
            <p data-id="element-4112">It's a mirror of how you typically operate at work.</p>
            <p data-id="element-4113">It takes about 10 minutes.</p>
            <p className="text-[#F5F5F5]" data-id="element-4114">Honest answers = accurate mirror.</p>
          </div>

          {/* Primary CTA */}
          <div className="space-y-4 pt-4" data-id="element-4115">
            <button onClick={handleBegin} className="w-full px-8 py-4 bg-[#F5F5F5] text-[#0A0A0A] font-semibold text-sm tracking-widest uppercase hover:bg-gray-200 transition-colors" data-id="element-4116">
              Begin Diagnostic
            </button>

            {/* Tiny Subtext */}
            <p className="text-xs text-gray-600 text-center" data-id="element-4117">
              You'll see your core work pattern at the end.
            </p>
          </div>

          {/* Optional Secondary Action */}
          <div className="text-center pt-2" data-id="element-4118">
            <button onClick={handleBack} className="text-sm text-gray-500 hover:text-gray-400 transition-colors" data-id="element-4119">
              Not now
            </button>
          </div>
        </div>
      </div>
    </>;
}